import { formatDate } from '@angular/common';
import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { OpenLinkById } from 'src/app/common/services/openlinkbyid';
import { PcsFilterCriteriaforHighlight } from '../../../common/models/PendingIntegeration';
import { CommonDataService } from '../../../common/services/common-data.service';
import { HttpcallService } from '../../../common/services/httpcall.service';
import { LoginService } from '../../../common/services/Login.service';
import { SessionService } from '../../../common/services/Session.service';
import scrollIntoView from 'scroll-into-view-if-needed';
import * as synonymsData from '../../../../assets/Resources/synoyms.json';

@Component({
  selector: 'app-page-viewer',
  templateUrl: './page-viewer.component.html',
  styleUrls: ['./page-viewer.component.css']
})

export class PageViewerComponent implements OnInit, AfterViewChecked, OnDestroy {

  title: string = "";
  body;
  publicationId
  pageId;
  paragraphs: string[];
  TopicTitle: any;
  topicheader: string;
  pageHeading;
  pageName: string = "";
  printqueueAdded: boolean = false;
  paragraphIdsList: any[] = [];
  printqueueAddedList: any[] = [];
  paraArticleId: string = "";
  addedparagraphList = [];
  event$: Subscription;
  archivePage: boolean = false;
  TopicBody: string[];
  topicBodyContent: any = [];
  paragraph: string[];
  topicheader2: string;
  PendingContentPage: boolean = false;
  FiscalDate: any;
  PeriodType: string;
  fillingStatus: string;
  periodTypeLabel: any;
  paragraphIdHighlight: string[] = [];
  sectionHeader: any;
  fillingStatus_Label: any;
  showingContent_Label: any;
  pc_Edit: any;
  pc_reset: any;
  search: PcsFilterCriteriaforHighlight = new PcsFilterCriteriaforHighlight();
  ShowSecContent: boolean = true;
  hasSecContent: any;
  secContent: any = [];
  crossreferencedParaID: any;
  crossreferencestandardType: any;
  crossreferencestandardNumber: any;
  crossreferenceparagraphNumber: any;
  displayWhatLinksHereBackButton = false;
  whatLinksHereBackButtonTitle: string;
  whatLinksHereBackButtonUrl: string;
  IsContentPage: boolean;
  routerPart: string[];
  s3ImageBasePath: string = "";
  PendingContentMergeList: any[];
  glossaryTerm: string = "";
  isRouteNav: boolean = false;
  pageurl: string = "";
  synonyms: any;

  isSearchLink: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router, private httpCallService: HttpcallService,
    public commonDataService: CommonDataService, private loginService: LoginService,
    private graphQLService: GraphqlService,
    private sanitizer: DomSanitizer,
    private openLink: OpenLinkById, private session: SessionService,
    private browserTitle: Title
  ) {
    //sessionStorage.removeItem('inPageScrollPositionRetentionData');
    //sessionStorage.removeItem('inPageScrollCurrentNum');
    //sessionStorage.removeItem('inPageScrollLastUrl');
    if (this.router.url.split("/").length > 2) {
      this.routerPart = this.router.url.split("/");
      this.publicationId = this.routerPart[1];
      this.pageId = this.routerPart[2];
      this.pageurl = this.publicationId + "/" + this.pageId;
    }
    else {
      let navPath = this.router.url.slice(1).split("-");
      let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
      this.routerPart = url.split("/");
      this.publicationId = this.routerPart[0];
      this.pageId = this.routerPart[1];
      this.pageurl = this.publicationId + "/" + this.pageId;
      this.isRouteNav = true;
    }

    this.paraFound = false;
    this.destinationPara = "";
    this.getUserId();
  }

  ngOnDestroy() {
    if (this.pcsIntegratedFlag != undefined && this.pcsIntegratedFlag != null) {
      this.pcsIntegratedFlag.unsubscribe();
    }
    if (this.event$ != undefined && this.event$ != null) {
      this.event$.unsubscribe();
    }
    if (this.pendingContentSystemLabel != undefined && this.pendingContentSystemLabel != null) {
      this.pendingContentSystemLabel.unsubscribe();
    }
    if (this.mainCall != undefined && this.mainCall != null) {
      this.mainCall.unsubscribe();
    }
    if (this.sessionCall != undefined && this.sessionCall != null) {
      this.sessionCall.unsubscribe();
    }
    if (this.breadcrumbSession != undefined && this.breadcrumbSession != null) {
      this.breadcrumbSession.unsubscribe();
    }
    if (this.relatedProposedASUCall != undefined && this.relatedProposedASUCall != null) {
      this.relatedProposedASUCall.unsubscribe();
    }
    if (this.pageDataCall != undefined && this.pageDataCall != null) {
      this.pageDataCall.unsubscribe();
    }
    if (this.globalDataCall != undefined && this.globalDataCall != null) {
      this.globalDataCall.unsubscribe();
    }
    if (this.navPathTreeCall != undefined && this.navPathTreeCall != null) {
      this.navPathTreeCall.unsubscribe();
    }
    if (this.destroy$) {
      this.destroy$.next();
      this.destroy$.complete();
    }

    this.paragraphIdsList = [];
    this.printqueueAddedList = [];
    localStorage.removeItem("SetPrintQueueSession");
    localStorage.removeItem("printQueueCount");
    this.commonDataService.printCount.next("0");
    //sessionStorage.removeItem('inPageScrollPositionRetentionData');
    //sessionStorage.removeItem('inPageScrollCurrentNum');
    //sessionStorage.removeItem('inPageScrollLastUrl');
    this.secContent = [];
    this.hasSecContent = false;
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");

    localStorage.removeItem("hilightedElasticTerms");
    localStorage.removeItem("searchTerm");
  }

  topic_subtopicNum: string = "";
  parameter;
  proposedCall;
  showProposedASU: boolean = false;
  //ngAfterViewCheckedCounter: number = 0;
  ngOnInit(): void {
    this.synonyms = synonymsData;
    sessionStorage.removeItem("paragraphNum");
    this.paragraphIdsList = [];
    this.printqueueAddedList = [];
    this.isStarting = true;
    this.formattedXBRLFlag = false;
    this.commonDataService.showLoader.next(true);
    this.archivePage = false;
    this.paragraphIdsList = [];
    let crossReferenceObject = this.commonDataService.crossreferencedParaID.getValue();
    crossReferenceObject = crossReferenceObject == null || crossReferenceObject?.paragraphID == "" || crossReferenceObject == undefined ? JSON.parse(localStorage.getItem("crossreferencedParaID")) : crossReferenceObject;
    this.crossreferencedParaID = crossReferenceObject?.paragraphID;
    if (crossReferenceObject?.paragraphID && crossReferenceObject?.standardType && crossReferenceObject?.standardNumber) {
      this.crossreferencestandardType = crossReferenceObject.standardType;
      this.crossreferencestandardNumber = crossReferenceObject.standardNumber;
      this.crossreferenceparagraphNumber = crossReferenceObject.paragraphNumber;
      this.commonDataService.crossreferencedParaID.next(null);
      localStorage.removeItem("crossreferencedParaID");
    }
    this.glossaryTerm = this.commonDataService.glossaryTermFromContentPageBackButton.getValue();
    this.commonDataService.printqueueCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        let _id = data.articleId;
        let keyName = this.pageHeading;
        let section = data.section;
        let paragraphId = data.paragraphId;
        let isSECPara = document.getElementById('SecContentStarted')?.innerHTML?.toLowerCase()?.includes(paragraphId?.trim()?.toLowerCase());
        let isGlossaryPara = !(/\d/.test(paragraphId));
        if (isSECPara) {
          isSECPara = true;
        }
        else {
          isSECPara = false;
        }
        if (keyName != undefined) {
          if (data.toggleValue.toString() == 'true') {
            this.printqueueAdded = true;
            //document.getElementById(_id).style.display = "";
            /*if (this.paragraphIdsList == null) {*/
            //this.paragraphIdsList = [];
            //this.printqueueAddedList = [];
            /*}*/
            this.paragraphIdsList.push({ id: paragraphId, isSecParagraph: isSECPara, isGlossaryParagraph: isGlossaryPara });
            this.printqueueAddedList.push({ guid: data.articleId, topicNumber: data.topic, subTopicNumber: data.subtopic, sectionNumber: section });
            let body = {
              ParagraphIdsList: this.paragraphIdsList,
              printQueueAddedList: this.printqueueAddedList
            };
            localStorage.setItem("SetPrintQueueSession", JSON.stringify(body));
          }
          else {
            this.printqueueAdded = false;
            //document.getElementById(_id).style.display = "none";
            this.remove(this.paragraphIdsList, paragraphId);
            //this.remove(this.printqueueAddedList, data.articleId);
            this.printqueueAddedList = this.printqueueAddedList.filter(item => item.guid != data.articleId);
            const _body = {
              ParagraphIdsList: this.paragraphIdsList,
              printQueueAddedList: this.printqueueAddedList
            };
            localStorage.setItem("SetPrintQueueSession", JSON.stringify(_body));
          }
        }
      }
    });
    if (this.routerPart[3] != null && this.routerPart[3] != undefined && this.routerPart[3] != "" && this.routerPart[3].includes("noticeToConstituents")) {
      this.IsContentPage = false;
      this.getOtherSourceContent(this.routerPart[1], this.routerPart[2]);
    }
    if (localStorage.getItem("isPendingContentPage") == 'true') {
      var isNormalPage = this.IsContentPage && !this.parameter.includes("75");
      localStorage.setItem("isContentPage", String(isNormalPage));
    }
    this.event$
      = this.router.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          /*if (this.router.url.split("/")[2] != this.pageId) {*/
          //sessionStorage.removeItem('inPageScrollPositionRetentionData');
          //sessionStorage.removeItem('inPageScrollCurrentNum');
          //sessionStorage.removeItem('inPageScrollLastUrl');
          sessionStorage.removeItem("paragraphNum");
          let whatLinksHereRouteValues = this.router?.getCurrentNavigation()?.extras?.state;
          this.outcome = false;
          this.outcomeXBRL = false;
          this.formattedXBRLFlag = false;
          this.paragraphTitleContentSec = [];
          this.topicBodyContent = [];
          this.paragraphIdsList = [];
          this.printqueueAddedList = [];
          this.isStarting = true;
          this.commonDataService.showLoader.next(true);
          this.paraFound = false;
          this.destinationPara = "";
          if (this.router.url.split("/").length > 2) {
            this.routerPart = this.router.url.split("/");
            this.publicationId = this.routerPart[1];
            this.pageId = this.routerPart[2];
            this.pageurl = this.publicationId + "/" + this.pageId;
            this.isRouteNav = false;
          }
          else {
            let navPath = this.router.url.slice(1).split("-");
            let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
            this.routerPart = url.split("/");
            this.publicationId = this.routerPart[0];
            this.pageId = this.routerPart[1];
            this.pageurl = this.publicationId + "/" + this.pageId;
            this.isRouteNav = true;
          }
          this.paraFound = false;
          this.crossreferencedParaID = this.commonDataService.crossreferencedParaID.getValue()?.paragraphID;
          localStorage.removeItem("crossreferencedParaID");
          this.commonDataService.glossaryTermFromContentPageBackButton.next("");
          this.glossaryTerm = this.commonDataService.glossaryTermFromContentPageBackButton.getValue();

          this.getBreadcrumb();
          if (this.crumbData.length != 0) {
            if (this.crumbData[0] != "Other Sources") {
              this.IsContentPage = true;
              if (whatLinksHereRouteValues != null && whatLinksHereRouteValues != undefined) {
                if (('backLabel' in whatLinksHereRouteValues) && ('backUrl' in whatLinksHereRouteValues)) {
                  this.displayWhatLinksHereBackButton = true;
                  this.whatLinksHereBackButtonTitle = whatLinksHereRouteValues.backLabel;
                  this.whatLinksHereBackButtonUrl = whatLinksHereRouteValues.backUrl;
                }
                else {
                  this.displayWhatLinksHereBackButton = false;
                }
              }
              else {
                this.displayWhatLinksHereBackButton = false;
              }
              if (this.crumbData.length != 0) {
                this.pageNumsForCount = "";
                this.pageNumsCountForHistory = "";
                this.breadcrumbPath = this.crumbData[0] + "~";
                for (let i = 1; i < this.crumbData.length; i++) {
                  if (i != this.crumbData.length - 1) {
                    if (!this.crumbData[i].split(" ")[0].includes("X")) {
                      this.pageNumsForCount += this.crumbData[i].split(" ")[0] + "-";
                      this.pageNumsCountForHistory += this.crumbData[i].split(" ")[0] + "-";
                      this.breadcrumbPath += this.crumbData[i] + "~";
                    }
                  }
                  else {
                    if (this.crumbData[i].split(" ")[0].startsWith('S')) {
                      this.pageNumsForCount += this.crumbData[i].split(" ")[0].substring(1);
                    } else { this.pageNumsForCount += this.crumbData[i].split(" ")[0]; }
                    this.pageNumsCountForHistory += this.crumbData[i].split(" ")[0];
                    this.breadcrumbPath += this.crumbData[i];
                  }
                }
                this.parameter = this.pageNumsForCount.split("-");
                this.topic_subtopicNum = this.parameter[0] + "-" + this.parameter[1] + "-";

                this.commonDataService.navDataContentPage.next(this.crumbData);
                this.commonDataService.emailId.next(this.loggedInUserInfo.user.email);
                this.emailId = this.loggedInUserInfo.user.email;
                this.userRole = this.loggedInUserInfo.user.roles;

                if (this.IsContentPage && this.menuListItems.length == 0) {
                  this.getActionMenuLabels();
                }
                //this.breadcrumbPath = this.crumbData.join("~");
                //this.commonDataService.breadcrumbPath.next(this.breadcrumbPath);
                this.getSecContent();

                if (!this.parameter[2].includes("75")) {
                  this.proposedCall = this.graphQLService.getRelatedpropsedASU(this.parameter[0], this.parameter[1], this.parameter[2]).subscribe(relatedASUs => { if (relatedASUs?.hits?.hitsList?.length > 0) { this.showProposedASU = true; } else { this.showProposedASU = false; } })
                }
              }
              this.PendingContentPage = false;
              // localStorage.setItem("isPendingContentPage", String(this.PendingContentPage));

              //this.getSecContent();
              this.commonDataService.annotationWithinContent.next(null);
            }
            else {
              this.IsContentPage = false;
              this.commonDataService.navDataContentPage.next(this.crumbData);
              this.browserTitle.setTitle(this.crumbData[1] + " - " + this.crumbData[2]);

              this.getOtherSourceContent(this.publicationId, this.pageId);
            }
          }
          else if (this.routerPart[3] != null && this.routerPart[3] != undefined && this.routerPart[3] != "" && this.routerPart[3].includes("noticeToConstituents")) {
            this.IsContentPage = false;
            this.getOtherSourceContent(this.routerPart[1], this.routerPart[2])
          }
          localStorage.removeItem("SetPrintQueueSession");
          localStorage.removeItem("printQueueCount");
          this.commonDataService.printCount.next("0");
          if (localStorage.getItem("isPendingContentPage") == 'true') {
            let isNormalPage1 = this.IsContentPage && !this.parameter.includes("75");
            localStorage.setItem("isContentPage", String(isNormalPage1));
          }
          // }
          //else {
          //  console.log("Hi1")
          //    var otherSourceUrlPartsnode = document.getElementById(this.router.url.split("/")[3]);
          //    scrollIntoViewIfNeeded(otherSourceUrlPartsnode, {
          //      block: 'start',
          //      inline: 'start',
          //      boundary: document.getElementsByTagName('app-main-content')[0]
          //    })
          //  }
        })
    this.commonDataService.printCount.pipe(takeUntil(this.destroy$)).subscribe(data => {

      if (data == "toggleOff") {
        this.paragraphIdsList = [];
        this.printqueueAddedList = [];
      }
    })
    this.commonDataService.printContentHideShow.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data == "Hide") {
        setTimeout(() => {
          let hide = document.getElementsByClassName("print-content-hide")
          Array.prototype.forEach.call(hide, function (obj) {
            obj.style.display = ""
          });
        }, 500)

        this.commonDataService.printContentHideShow.next(null);
      }
    });

    this.commonDataService.showSources.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        let article = document.getElementById(data.paragraphId);
        if (article != null) {
          let sfragment = article.getElementsByClassName('sfragment') as HTMLCollectionOf<HTMLElement>;

          if (sfragment && sfragment?.length) {
            let sfragmentDataStringNew = "";
            for (let i = 0; i < sfragment?.length; i++) {
              let sfragmentData1 = sfragment[i].getElementsByClassName('sfragment-data');
              for (let j = 0; j < sfragmentData1?.length; j++) {
                let standardName = sfragmentData1[j].getElementsByClassName('sfragment-standard-name');
                let standardNumber = sfragmentData1[j].getElementsByClassName('sfragment-standard-number');
                let paraNumber = sfragmentData1[j].getElementsByClassName('sfragment-para-number');

                if (standardName && standardName?.length && standardNumber && standardNumber?.length) {
                  sfragmentDataStringNew += standardName[0].innerHTML + " " + standardNumber[0]?.innerHTML;
                }
                if (paraNumber && paraNumber?.length) {
                  sfragmentDataStringNew += ", paragraph " + paraNumber[0]?.innerHTML;
                }
                if (sfragmentDataStringNew != "") {
                  sfragmentData1[j].innerHTML = sfragmentDataStringNew;
                }
                sfragmentDataStringNew = "";
              }
            }
          }
          let sfragmentData = article.getElementsByClassName('sfragment-data') as HTMLCollectionOf<HTMLElement>;

          if (data.toggleValue) {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.add('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData.length; i++) {
              sfragmentData[i].classList.add('show-sources-sfragment-data');
              sfragmentData[i].style.display = 'inline';
            }
          }
          else {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.remove('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData.length; i++) {
              sfragmentData[i].classList.remove('show-sources-sfragment-data');
              sfragmentData[i].style.display = 'none';
            }
          }
        }
      }
    });

    this.commonDataService.displayAllSourcesForPrint.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        let article = document.getElementById("printPara");
        if (article != null) {
          let sfragment = article.getElementsByClassName('sfragment') as HTMLCollectionOf<HTMLElement>;
          if (sfragment && sfragment?.length) {
            let sfragmentDataStringNew = "";
            for (let i = 0; i < sfragment?.length; i++) {
              let sfragmentData2 = sfragment[i].getElementsByClassName('sfragment-data');
              for (let j = 0; j < sfragmentData2?.length; j++) {
                let standardName = sfragmentData2[j].getElementsByClassName('sfragment-standard-name');
                let standardNumber = sfragmentData2[j].getElementsByClassName('sfragment-standard-number');
                let paraNumber = sfragmentData2[j].getElementsByClassName('sfragment-para-number');

                if (standardName && standardName?.length && standardNumber && standardNumber?.length) {
                  sfragmentDataStringNew += standardName[0].innerHTML + " " + standardNumber[0]?.innerHTML;
                }
                if (paraNumber && paraNumber?.length) {
                  sfragmentDataStringNew += ", paragraph " + paraNumber[0]?.innerHTML;
                }
                if (sfragmentDataStringNew != "") {
                  sfragmentData2[j].innerHTML = sfragmentDataStringNew;
                }
                sfragmentDataStringNew = "";
              }
            }
          }
          let sfragmentData = article.getElementsByClassName('sfragment-data') as HTMLCollectionOf<HTMLElement>;

          if (data.toggleValue) {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.add('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData.length; i++) {
              sfragmentData[i].classList.add('show-sources-sfragment-data');
              sfragmentData[i].style.display = 'inline';
            }
          }
          else {

            for (let i = 0; i < sfragment.length; i++) {
              sfragment[i].classList.remove('show-sources-sfragment');
            }
            for (let i = 0; i < sfragmentData.length; i++) {
              sfragmentData[i].classList.remove('show-sources-sfragment-data');
              sfragmentData[i].style.display = 'none';
            }
          }
        }
      }
    });
  }
  crossRefBack() {
    this.commonDataService.backbuttoncrossreference.next(true);
    this.router.navigateByUrl("/crossreference");
  }

  glossaryBack() {
    this.commonDataService.glossaryTermBackButtonClicked.next(true);
    this.router.navigateByUrl("/MasterGlossary");
  }
  s3Path;
  destinationPara: string = "";
  isStarting: boolean = true;
  paraFound: boolean = false;
  ngAfterViewChecked(): void {
    let para = sessionStorage.getItem("paragraphNum");
    if (localStorage.getItem('backButtonClicked') === 'false') {
      if (this.isStarting) {
        if (!(para === "undefined" || para === null)) {
          let paraSplit = para.split("-");
          let para2 = "";
          if (paraSplit.length == 4) {
            para2 = paraSplit[1] + "-" + paraSplit[0] + "-" + paraSplit[2] + "-" + paraSplit[3];
          }
          if (document.getElementById(para) != null) {

            //if (this.ngAfterViewCheckedCounter != 10) {
            //  this.ngAfterViewCheckedCounter += 1;
            const node = document.getElementById(para);
            setTimeout(() => {
              scrollIntoView(node, {
                scrollMode: 'always',
                block: 'start',
                inline: 'start',
                boundary: document.getElementsByTagName('app-main-content')[0]
              })
              const element = document.getElementById(para);
              const rect = element.getBoundingClientRect();
              const documentHeight = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
              const viewPortHeight = window.innerHeight;
              const top1Percent = viewPortHeight * 0.01;
              const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0]?.scrollTop;
              const maxScrollTop = documentHeight - viewPortHeight;
              if (rect.top < top1Percent || scrollTop >= maxScrollTop) {
                sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
              }
            }, 2000);
            //}

            // let node = document.getElementById(para);
            // scrollIntoViewIfNeeded(node, {
            //   block: 'start',
            //   inline: 'start',
            //   boundary: document.getElementsByTagName('app-main-content')[0]
            // })

            this.destinationPara = document.getElementById(para).innerText;
            if (!this.paraFound && this.routerPart[3]?.startsWith("GUID")) {
              this.saveHistoryWithParagraph();
            }
          }

          else if (document.getElementById(para2) != null) {
            para = para2;
            //if (this.ngAfterViewCheckedCounter != 10) {
            //  this.ngAfterViewCheckedCounter += 1;
            const node = document.getElementById(para2);
            setTimeout(() => {
              scrollIntoView(node, {
                scrollMode: 'always',
                block: 'start',
                inline: 'start',
                boundary: document.getElementsByTagName('app-main-content')[0]
              })
              const element = document.getElementById(para2);
              const rect = element.getBoundingClientRect();
              const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
              const viewPortHeight = window.innerHeight;
              const top1Percent = viewPortHeight * 0.01;
              const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
              const maxScrollTop = documentHeight - viewPortHeight;
              if (rect.top < top1Percent || scrollTop >= maxScrollTop) {
                sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
              }
            }, 2000);
            //}

            // let node = document.getElementById(para);
            // scrollIntoViewIfNeeded(node, {
            //   block: 'start',
            //   inline: 'start',
            //   boundary: document.getElementsByTagName('app-main-content')[0]
            // })

            this.destinationPara = document.getElementById(para2).innerText;
            if (!this.paraFound && this.routerPart[3]?.startsWith("GUID")) {
              this.saveHistoryWithParagraph();
            }
          }
          else {
            let paraCopy = para;
            let para0 = false;
            let para1 = false;
            for (let i = 0; i < this.crumbData.length; i++) {
              if (this.crumbData[i].includes(paraCopy.split('-')[0])) {
                para0 = true;
              }
              if (this.crumbData[i].includes(paraCopy.split('-')[1])) {
                para1 = true;
              }
            }

            if (para0 && para1) {
              let newParaId = para.split("-")[1] + "-" + para.split('-')[0] + "-" + para.split('-')[2] + "-" + para.split('-')[3];
              if (document.getElementById(newParaId) != null) {

                //if (this.ngAfterViewCheckedCounter != 10) {
                //  this.ngAfterViewCheckedCounter += 1;
                const node = document.getElementById(para);
                setTimeout(() => {
                  scrollIntoView(node, {
                    scrollMode: 'always',
                    block: 'start',
                    inline: 'start',
                    boundary: document.getElementsByTagName('app-main-content')[0]
                  })
                  const element = document.getElementById(para);
                  const rect = element.getBoundingClientRect();
                  const documentHeight = document.getElementsByTagName('app-main-content')[0].scrollHeight;
                  const viewPortHeight = window.innerHeight;
                  const top1Percent = viewPortHeight * 0.01;
                  const scrollTop = window.scrollY || document.getElementsByTagName('app-main-content')[0].scrollTop;
                  const maxScrollTop = documentHeight - viewPortHeight;
                  if (rect.top < top1Percent || scrollTop >= maxScrollTop) {
                    sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
                  }
                }, 2000);
                //}

                // let node = document.getElementById(para);
                // scrollIntoViewIfNeeded(node, {
                //   block: 'start',
                //   inline: 'start',
                //   boundary: document.getElementsByTagName('app-main-content')[0]
                // })

                this.destinationPara = document.getElementById(para).innerText;
                if (!this.paraFound && this.routerPart[3]?.startsWith("GUID")) {
                  this.saveHistoryWithParagraph();
                }
              }
            }
          }
        }
      }
    }
    else {
      if (this.isStarting) {
        if (!(para === "undefined" || para === null)) {
          if (document.getElementById(para) != null) {
            this.destinationPara = document.getElementById(para).innerText;
            if (!this.paraFound && this.routerPart[3]?.startsWith("GUID")) {
              this.saveHistoryWithParagraph();
            }
            sessionStorage.removeItem("paragraphNum"); this.isStarting = false;
          }
        }
      }
    }

    if (localStorage.getItem("DefaultSecView") == "false") {
      this.ShowSecContent = false;
    }
    else {
      this.ShowSecContent = true;
    }
    localStorage.removeItem("isSearchLink");
  }
  loadPendingDataForContentPage(resultPendingContent) {
    if (resultPendingContent.isPCSIntegrated) {
      this.getPCSLabels();
      this.PendingContentPage = resultPendingContent.isPCSIntegrated;
      // localStorage.setItem("isPendingContentPage", String(this.PendingContentPage));
      this.FiscalDate = "Fiscal year beginning " + formatDate(resultPendingContent.date, 'MM/dd/yyyy', 'en-US');
      this.fillingStatus = resultPendingContent.filingStatus;
      this.PeriodType = resultPendingContent.periodtype;
      if (resultPendingContent.pcsIntegrationData != null && resultPendingContent.pcsIntegrationData.length > 0) {
        this.PendingContentMergeList = resultPendingContent.pcsIntegrationData;
        //condition to be removed and made  this.PendingContentPage = true if para number to be not considered
        // this.PendingContentMergeList.length > 0 ? this.PendingContentPage = true : this.PendingContentPage = false;
      }
    }

  }
  EditPCS() {
    let PCS = { fillingStatus: this.fillingStatus, periodType: this.PeriodType, Date: this.FiscalDate.split("Fiscal year beginning ")[1] };
    localStorage.setItem("PCSInput", JSON.stringify(PCS));
    this.commonDataService.EditFromContentPage.next(true);
    localStorage.removeItem("backlabel");
    localStorage.removeItem("backUrl");
    this.router.navigateByUrl("/pendingcontentsystem");
  }
  pcsIntegratedFlag: Subscription;
  ResetPCS() {
    this.pcsIntegratedFlag = this.graphQLService.SetPCSIntegratedFlag(false).subscribe(data => {
      this.PendingContentPage = false;
      localStorage.setItem("isPendingContentPage", String(this.PendingContentPage));
      this.PendingContentMergeList = [];
      this.reloadCurrentRoute()
    })

  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/#', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  pendingContentSystemLabel: Subscription;
  getPCSLabels() {
    this.pendingContentSystemLabel = this.graphQLService.getPendingContentSystemLabels().subscribe(data => {
      if (data != "") {
        let labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.sectionHeader = labels.filter(x => x.key == "pc_contentheader").map(y => y.value);
        this.periodTypeLabel = labels.filter(x => x.key == "pc_periodType").map(y => y.value);
        this.fillingStatus_Label = labels.filter(x => x.key == "pc_filingStatus").map(y => y.value);
        this.showingContent_Label = labels.filter(x => x.key == "pc_Showingcontent_label").map(y => y.value);
        this.pc_Edit = labels.filter(x => x.key == "pc_Edit").map(y => y.value);
        this.pc_reset = labels.filter(x => x.key == "pc_reset").map(y => y.value);
      }
    });
  }
  remove(arr, what) {
    arr.sort().forEach(function (value, index) {
      if (value.id === what) {
        arr.splice(index, 1);
      }
    });
  }
  bookmarkCountNormal: any = {};
  annotationCountNormal: any = {};
  bookmarkCountSec: any = {};
  annotationCountSec: any = {};
  mainCall: Subscription;
  taxonomyUrl: string = "";
  getPageContent() {
    this.isSearchLink = Boolean(localStorage.getItem("isSearchLink"));

    this.topicBodyContent = [];
    if (this.userRole != "Basic" && (!this.parameter[2].includes("75"))) {
      if (this.hasActualContent && this.hasSecContent) {
        let pageHeaderNormal = { "publicationId": this.normalUrl.split("/")[0], "pageId": this.normalUrl.split("/")[1], "pageName": this.normalPageName, "pageNavPath": this.pageNumsForCount, "PendingContentIntegrationData": this.PendingContentMergeList };
        let paragraphActionInputBodyNormal = { NavigationPath: this.pageNumsForCount, Application: "" };
        let navPathSec = this.pageNumsForCount.split("-")[2].startsWith('S') ? this.pageNumsForCount : this.parameter[0] + "-" + this.parameter[1] + "-S" + this.parameter[2];
        let pageHeaderSec = { "publicationId": this.secUrl.split("/")[0], "pageId": this.secUrl.split("/")[1], "pageName": "S" + this.normalPageName, "pageNavPath": navPathSec, "PendingContentIntegrationData": this.PendingContentMergeList };
        let paragraphActionInputBodySec = { NavigationPath: navPathSec, Application: "" };

        this.mainCall = forkJoin([
          this.graphQLService.getPageData(pageHeaderNormal), this.graphQLService.getS3BucketImagePath(), this.graphQLService.getPageData(pageHeaderSec),
          this.graphQLService.GetPendingContentMergeList(this.publicationId, this.pageId)
        ]).subscribe(([result, s3BucketImagePath, resultSec, resultPendingContent]) => {

          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          //this.topicBodyContent = result.topicBodyContent;
          //this.paragraphTitleContent = result.formattedResponse;
          //this.paragraphTitleContentSec = resultSec.formattedResponse;
          // this.topicBodyContentSec = resultSec.topicBodyContent;
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {
            let searchTerm8 = localStorage.getItem("searchTerm");
            let synonymsData1 = this.synonyms[searchTerm8];
            this.topicBodyContent = this.highlightSearchText(searchTerm8, synonymsData1, result.topicBodyContent);
            this.paragraphTitleContent = this.highlightSearchText(searchTerm8, synonymsData1, result.formattedResponse);
            this.paragraphTitleContentSec = this.highlightSearchText(searchTerm8, synonymsData1, resultSec.formattedResponse);
            this.topicBodyContentSec = this.highlightSearchText(searchTerm8, synonymsData1, resultSec.topicBodyContent);
          } else {
            this.topicBodyContent = result.topicBodyContent;
            this.paragraphTitleContent = result.formattedResponse;
            this.paragraphTitleContentSec = resultSec.formattedResponse;
            this.topicBodyContentSec = resultSec.topicBodyContent;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.title = result.contentPageTitle;
          this.getParagraphs(result);
          this.loadPendingDataForContentPage(resultPendingContent);
          this.getParagraphsSec(resultSec);
          this.s3ImageBasePath = s3BucketImagePath;
          this.getPrintSession();
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
        this.httpCallService.getBookmarkCount(paragraphActionInputBodyNormal).subscribe(respBookmarkCount => { this.bookmarkCountNormal = respBookmarkCount; });
        this.httpCallService.getAnnotationCount(paragraphActionInputBodyNormal).subscribe(respAnnotationCount => { this.annotationCountNormal = respAnnotationCount; });
        this.httpCallService.getBookmarkCount(paragraphActionInputBodySec).subscribe(respBookmarkCountSec => { this.bookmarkCountSec = respBookmarkCountSec; });
        this.httpCallService.getAnnotationCount(paragraphActionInputBodySec).subscribe(respAnnotationCountSec => { this.annotationCountSec = respAnnotationCountSec; });
      } else if (this.hasActualContent && (!this.hasSecContent)) {
        let pageHeaderNormal = { "publicationId": this.normalUrl.split("/")[0], "pageId": this.normalUrl.split("/")[1], "pageName": this.normalPageName, "pageNavPath": this.pageNumsForCount, "PendingContentIntegrationData": this.PendingContentMergeList };
        let paragraphActionInputBodyNormal = { NavigationPath: this.pageNumsForCount, Application: "" };
        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderNormal), this.graphQLService.getS3BucketImagePath(), this.graphQLService.GetPendingContentMergeList(this.publicationId, this.pageId)
        ]).subscribe(([result, s3BucketImagePath, resultPendingContent]) => {
          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          //  this.topicBodyContent = result.topicBodyContent;
          //  this.paragraphTitleContent = result.formattedResponse;
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {
            let searchTerm7 = localStorage.getItem("searchTerm");
            let synonymsData2 = this.synonyms[searchTerm7];
            this.topicBodyContent = this.highlightSearchText(searchTerm7, synonymsData2, result.topicBodyContent);
            this.paragraphTitleContent = this.highlightSearchText(searchTerm7, synonymsData2, result.formattedResponse);
          } else {
            this.topicBodyContent = result.topicBodyContent;
            this.paragraphTitleContent = result.formattedResponse;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.paragraphTitleContentSec = [];
          this.loadPendingDataForContentPage(resultPendingContent);
          this.title = result.contentPageTitle;
          this.getParagraphs(result);
          this.s3ImageBasePath = s3BucketImagePath;
          this.getPrintSession();
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
        this.httpCallService.getBookmarkCount(paragraphActionInputBodyNormal).subscribe(respBookmarkCount => { this.bookmarkCountNormal = respBookmarkCount; });
        this.httpCallService.getAnnotationCount(paragraphActionInputBodyNormal).subscribe(respAnnotationCount => { this.annotationCountNormal = respAnnotationCount; });
      }
      else if ((!this.hasActualContent) && this.hasSecContent) {
        let navPathSec = this.pageNumsForCount.split("-")[2].startsWith('S') ? this.pageNumsForCount : this.parameter[0] + "-" + this.parameter[1] + "-S" + this.parameter[2];
        let pageHeaderSec = { "publicationId": this.secUrl.split("/")[0], "pageId": this.secUrl.split("/")[1], "pageName": "S" + this.normalPageName, "pageNavPath": navPathSec, "PendingContentIntegrationData": this.PendingContentMergeList };
        let paragraphActionInputBodySec = { NavigationPath: navPathSec, Application: "" };
        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderSec), this.graphQLService.getS3BucketImagePath(), this.graphQLService.GetPendingContentMergeList(this.publicationId, this.pageId)
        ]).subscribe(([result, s3BucketImagePath, resultPendingContent]) => {

          this.paragraphTitleContent = [];
          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          // this.paragraphTitleContentSec = result.formattedResponse;
          // this.topicBodyContentSec = result.topicBodyContent;
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {
            let searchTerm6 = localStorage.getItem("searchTerm");
            let synonymsData3 = this.synonyms[searchTerm6];
            this.paragraphTitleContentSec = this.highlightSearchText(searchTerm6, synonymsData3, result.formattedResponse);
            this.topicBodyContentSec = this.highlightSearchText(searchTerm6, synonymsData3, result.topicBodyContent);

          } else {
            this.paragraphTitleContentSec = result.formattedResponse;
            this.topicBodyContentSec = result.topicBodyContent;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.loadPendingDataForContentPage(resultPendingContent);
          this.title = result.contentPageTitle;
          this.getParagraphsSec(result);
          this.s3ImageBasePath = s3BucketImagePath;
          this.getPrintSession();
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
        this.httpCallService.getBookmarkCount(paragraphActionInputBodySec).subscribe(respBookmarkCountSec => { this.bookmarkCountSec = respBookmarkCountSec; });
        this.httpCallService.getAnnotationCount(paragraphActionInputBodySec).subscribe(respAnnotationCountSec => { this.annotationCountSec = respAnnotationCountSec; });
      }
    }
    else if (this.userRole == "Basic" && (!this.parameter[2].includes("75"))) {

      if (this.hasActualContent && this.hasSecContent) {
        let pageHeaderNormal = { "publicationId": this.normalUrl.split("/")[0], "pageId": this.normalUrl.split("/")[1], "pageName": this.normalPageName, "pageNavPath": this.pageNumsForCount, "PendingContentIntegrationData": this.PendingContentMergeList };
        let navPathSec = this.pageNumsForCount.split("-")[2].startsWith('S') ? this.pageNumsForCount : this.parameter[0] + "-" + this.parameter[1] + "-S" + this.parameter[2];
        let pageHeaderSec = { "publicationId": this.secUrl.split("/")[0], "pageId": this.secUrl.split("/")[1], "pageName": "S" + this.normalPageName, "pageNavPath": navPathSec, "PendingContentIntegrationData": this.PendingContentMergeList };

        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderNormal), this.graphQLService.getS3BucketImagePath(), this.graphQLService.getPageData(pageHeaderSec),
        this.graphQLService.GetPendingContentMergeList(this.publicationId, this.pageId)
        ]).subscribe(([result, s3BucketImagePath, resultSec, resultPendingContent]) => {

          this.title = result.contentPageTitle;

          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          //this.topicBodyContent = result.topicBodyContent;
          // this.paragraphTitleContent = result.formattedResponse;
          // this.paragraphTitleContentSec = resultSec.formattedResponse;

          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {
            let searchTerm5 = localStorage.getItem("searchTerm");
            let synonymsData4 = this.synonyms[searchTerm5];
            this.topicBodyContent = this.highlightSearchText(searchTerm5, synonymsData4, result.topicBodyContent);
            this.paragraphTitleContent = this.highlightSearchText(searchTerm5, synonymsData4, result.formattedResponse);
            this.paragraphTitleContentSec = this.highlightSearchText(searchTerm5, synonymsData4, resultSec.formattedResponse);
            this.topicBodyContentSec = this.highlightSearchText(searchTerm5, synonymsData4, resultSec.topicBodyContent);
          } else {
            this.topicBodyContent = result.topicBodyContent;
            this.paragraphTitleContent = result.formattedResponse;
            this.paragraphTitleContentSec = resultSec.formattedResponse;
            this.topicBodyContentSec = resultSec.topicBodyContent;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.getParagraphs(result);
          this.loadPendingDataForContentPage(resultPendingContent);
          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          /* this.topicBodyContentSec = resultSec.topicBodyContent; */
          //if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {

          //  let searchTerm4 = localStorage.getItem("searchTerm");
          //  let synonymsData5 = this.synonyms[searchTerm4];
          //  this.topicBodyContentSec = this.highlightSearchText(searchTerm4, synonymsData5, resultSec.topicBodyContent);
          //} else {
          //  this.topicBodyContentSec = resultSec.topicBodyContent;
          //}
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          /*this.title = this.apiResponseSec.contentPageTitle;*/
          this.getParagraphsSec(resultSec);
          this.s3ImageBasePath = s3BucketImagePath;
          this.getPrintSession();
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
      } else if (this.hasActualContent && (!this.hasSecContent)) {
        let pageHeaderNormal = { "publicationId": this.normalUrl.split("/")[0], "pageId": this.normalUrl.split("/")[1], "pageName": this.normalPageName, "pageNavPath": this.pageNumsForCount, "PendingContentIntegrationData": this.PendingContentMergeList };
        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderNormal), this.graphQLService.getS3BucketImagePath(), this.graphQLService.GetPendingContentMergeList(this.publicationId, this.pageId)
        ]).subscribe(([result, s3BucketImagePath, resultPendingContent]) => {

          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          /* this.topicBodyContent = result.topicBodyContent;*/
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {

            let searchTerm3 = localStorage.getItem("searchTerm");
            let synonymsData6 = this.synonyms[searchTerm3];
            this.topicBodyContent = this.highlightSearchText(searchTerm3, synonymsData6, result.topicBodyContent);
            this.paragraphTitleContent = this.highlightSearchText(searchTerm3, synonymsData6, result.formattedResponse);

          } else {
            this.topicBodyContent = result.topicBodyContent;
            this.paragraphTitleContent = result.formattedResponse;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.paragraphTitleContentSec = [];
          //this.paragraphTitleContent = result.formattedResponse;
          this.title = result.contentPageTitle;
          this.getParagraphs(result);
          this.loadPendingDataForContentPage(resultPendingContent);
          this.s3ImageBasePath = s3BucketImagePath;
          this.getPrintSession();
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
      }
      else if ((!this.hasActualContent) && this.hasSecContent) {
        let navPathSec = this.pageNumsForCount.split("-")[2].startsWith('S') ? this.pageNumsForCount : this.parameter[0] + "-" + this.parameter[1] + "-S" + this.parameter[2];
        let pageHeaderSec = { "publicationId": this.secUrl.split("/")[0], "pageId": this.secUrl.split("/")[1], "pageName": "S" + this.normalPageName, "pageNavPath": navPathSec, "PendingContentIntegrationData": this.PendingContentMergeList };
        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderSec), this.graphQLService.getS3BucketImagePath(), this.graphQLService.GetPendingContentMergeList(this.publicationId, this.pageId)
        ]).subscribe(([result, s3BucketImagePath, resultPendingContent]) => {
          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          /* this.topicBodyContentSec = result.topicBodyContent;*/
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {
            let searchTerm2 = localStorage.getItem("searchTerm");
            let synonymsData7 = this.synonyms[searchTerm2];
            this.paragraphTitleContentSec = this.highlightSearchText(searchTerm2, synonymsData7, result.formattedResponse);
            this.topicBodyContentSec = this.highlightSearchText(searchTerm2, synonymsData7, result.topicBodyContent);
          } else {
            this.paragraphTitleContentSec = result.formattedResponse;
            this.topicBodyContentSec = result.topicBodyContent;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.title = result.contentPageTitle;
          this.paragraphTitleContent = [];
          //this.paragraphTitleContentSec = result.formattedResponse;
          this.getParagraphsSec(result);
          this.loadPendingDataForContentPage(resultPendingContent);
          this.s3ImageBasePath = s3BucketImagePath;
          this.getPrintSession();
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
      }
    }
    else if (this.parameter[2].includes("75")) {
      this.xbrlData = {};
      if (this.hasActualContent && this.hasSecContent) {
        let pageHeaderNormal = { "publicationId": this.normalUrl.split("/")[0], "pageId": this.normalUrl.split("/")[1], "pageName": this.normalPageName, "pageNavPath": this.pageNumsForCount, "PendingContentIntegrationData": this.PendingContentMergeList };
        let navPathSec = this.pageNumsForCount.split("-")[2].startsWith('S') ? this.pageNumsForCount : this.parameter[0] + "-" + this.parameter[1] + "-S" + this.parameter[2];
        let pageHeaderSec = { "publicationId": this.secUrl.split("/")[0], "pageId": this.secUrl.split("/")[1], "pageName": "S" + this.normalPageName, "pageNavPath": navPathSec, "PendingContentIntegrationData": this.PendingContentMergeList };

        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderNormal), this.graphQLService.getPageData(pageHeaderSec), this.httpCallService.getXBRLSubTopic(this.parameter[0], this.parameter[1]), this.graphQLService.GetFASBTaxonomyUrl()
        ]).subscribe(([result, resultSec, xbrlData, taxonomyUrl]) => {

          this.title = result.contentPageTitle;
          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          // this.topicBodyContentSec = resultSec.topicBodyContent; 
          // this.topicBodyContent = result.topicBodyContent;
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {
            let searchTerm1 = localStorage.getItem("searchTerm");
            let synonymsData8 = this.synonyms[searchTerm1];
            this.topicBodyContent = this.highlightSearchText(searchTerm1, synonymsData8, result.topicBodyContent);
            this.topicBodyContentSec = this.highlightSearchText(searchTerm1, synonymsData8, resultSec.topicBodyContent);
          } else {
            this.topicBodyContent = result.topicBodyContent;
            this.topicBodyContentSec = resultSec.topicBodyContent;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.paragraphTitleContent = [];
          this.paragraphTitleContentSec = [];
          /*this.title = this.apiResponseSec.contentPageTitle;*/
          this.checkSECXBRL(xbrlData);
          this.taxonomyUrl = taxonomyUrl;
          this.getPrintSession();
          this.outcome = true;
          this.commonDataService.showLoader.next(false);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
      }
      else if (this.hasActualContent && (!this.hasSecContent)) {
        let pageHeaderNormal = { "publicationId": this.normalUrl.split("/")[0], "pageId": this.normalUrl.split("/")[1], "pageName": this.normalPageName, "pageNavPath": this.pageNumsForCount, "PendingContentIntegrationData": this.PendingContentMergeList };
        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderNormal), this.httpCallService.getXBRLSubTopic(this.parameter[0], this.parameter[1]), this.graphQLService.GetFASBTaxonomyUrl()
        ]).subscribe(([result, xbrlData, taxonomyUrl]) => {
          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          /*  this.topicBodyContent = result.topicBodyContent; */
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {

            let searchTerm0 = localStorage.getItem("searchTerm");
            let synonymsData9 = this.synonyms[searchTerm0];
            this.topicBodyContent = this.highlightSearchText(searchTerm0, synonymsData9, result.topicBodyContent);
          } else {
            this.topicBodyContent = result.topicBodyContent;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.title = result.contentPageTitle;
          this.paragraphTitleContent = [];
          this.paragraphTitleContentSec = [];
          this.getParagraphs(result);
          this.checkSECXBRL(xbrlData);
          this.taxonomyUrl = taxonomyUrl;
          this.getPrintSession();
          this.outcome = true;
          this.commonDataService.showLoader.next(false);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
      }
      else if ((!this.hasActualContent) && this.hasSecContent) {
        let navPathSec = this.pageNumsForCount.split("-")[2].startsWith('S') ? this.pageNumsForCount : this.parameter[0] + "-" + this.parameter[1] + "-S" + this.parameter[2];
        let pageHeaderSec = { "publicationId": this.secUrl.split("/")[0], "pageId": this.secUrl.split("/")[1], "pageName": "S" + this.normalPageName, "pageNavPath": navPathSec, "PendingContentIntegrationData": this.PendingContentMergeList };
        this.mainCall = forkJoin([this.graphQLService.getPageData(pageHeaderSec), this.httpCallService.getXBRLSubTopic(this.parameter[0], this.parameter[1]), this.graphQLService.GetFASBTaxonomyUrl()
        ]).subscribe(([result, xbrlData, taxonomyUrl]) => {
          // Start -- Commented & Added by Sagar for Search Highlithing FPP=58
          /*     this.topicBodyContentSec = result.topicBodyContent; */
          if (localStorage.getItem("searchNav") != null && localStorage.getItem("searchNav") != undefined && localStorage.getItem("searchNav") == "searchNavigation" && this.isSearchLink) {
            let searchTerm00 = localStorage.getItem("searchTerm");
            let synonymsData10 = this.synonyms[searchTerm00];
            this.topicBodyContentSec = this.highlightSearchText(searchTerm00, synonymsData10, result.topicBodyContent);
          } else {
            this.topicBodyContentSec = result.topicBodyContent;
          }
          // End -- Commented & Added by Sagar for Search Highlithing FPP=58
          this.title = result.contentPageTitle;
          this.paragraphTitleContent = [];
          this.paragraphTitleContentSec = [];
          this.getParagraphsSec(result);
          this.checkSECXBRL(xbrlData);
          this.taxonomyUrl = taxonomyUrl;
          this.getPrintSession();
          this.outcome = true;
          this.commonDataService.showLoader.next(false);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
      }
    }
  }
  formattedXBRLFlag: boolean = false;
  NormalXbrlContent;
  SECXbrlContent;
  HasXBRL: boolean = false;
  HasSecXBRL: boolean = false;
  xbrlTopic;
  xbrlSubtopic;
  outcomeXBRL: boolean = false;
  checkSECXBRL(xbrl) {
    this.HasXBRL = false;
    this.HasSecXBRL = false;
    this.NormalXbrlContent = [];
    this.SECXbrlContent = [];
    this.xbrlTopic = xbrl.topic;
    this.xbrlSubtopic = xbrl.subTopic;
    this.formattedXBRLFlag = xbrl.formattedXBRLFlag;
    if (!xbrl.formattedXBRLFlag) {
      if (xbrl.rawXBRL != null) {
        let xbrlContent = xbrl.rawXBRL.entries;
        for (let i = 0; i < xbrlContent?.length; i++) {
          this.HasXBRL = false;
          this.HasSecXBRL = false;
          for (let j = 0; j < xbrlContent[i].currentSubtopicLinks.length; j++) {
            if (xbrlContent[i].currentSubtopicLinks[j].section.startsWith('S') && this.hasSecContent && (!this.HasSecXBRL)) {
              this.SECXbrlContent.push(xbrlContent[i]);
              this.HasSecXBRL = true;
            }
            else if ((!xbrlContent[i].currentSubtopicLinks[j].section.startsWith('S')) && (this.hasActualContent) && (!this.HasXBRL)) {
              this.NormalXbrlContent.push(xbrlContent[i]);
              this.HasXBRL = true;
            }
            else if (this.HasXBRL && this.HasSecXBRL) { break; }
          }
        }
        if (this.SECXbrlContent.length > 0) { this.HasSecXBRL = true; } else { this.HasSecXBRL = false; }
        if (this.NormalXbrlContent.length > 0) { this.HasXBRL = true; } else { this.HasXBRL = false; }
      }
    }
    else {
      this.NormalXbrlContent = xbrl.normalXBRL;
      this.SECXbrlContent = xbrl.secXBRL;
      if (this.SECXbrlContent.length > 0) { this.HasSecXBRL = true; } else { this.HasSecXBRL = false; }
      if (this.NormalXbrlContent.length > 0) { this.HasXBRL = true; } else { this.HasXBRL = false; }
    }
    this.outcomeXBRL = true;
  }

  xbrlData;
  topicBodyContentSec: any = [];

  breadcrumbPath: string = "";
  saveHistory() {
    if (this.breadcrumbPath !== "") {
      let history = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "FASB", "CreateDate": "", "UpdateDate": "", "BreadCrumb": this.breadcrumbPath, "NavPath": this.pageNumsCountForHistory, "PageURL": this.router.url };
      this.historyHTTPCall(history);
    }
  }

  saveHistoryWithParagraph() {
    if (this.breadcrumbPath !== "") {
      //let history = { "Id": "-1", "CreateUserId": this.emailId, "UpdateUserId": "", "ApplicationSource": "FASB", "CreateDate": "", "UpdateDate": "", "BreadCrumb": this.breadcrumbPath, "NavPath": this.pageNumsForCount, "PageURL": this.router.url };
      if (this.routerPart.length == 4) {
        if (this.paraFound == true && this.routerPart[3].split("-").length == 4) {
          let history = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "FASB", "CreateDate": "", "UpdateDate": "", "BreadCrumb": this.breadcrumbPath, "NavPath": this.routerPart[3], "PageURL": this.router.url };
          this.historyHTTPCall(history);
        }
        else if (this.paraFound == false && this.routerPart[3].split("-").length == 3 && (!this.routerPart[3]?.startsWith("GUID"))) {
          let history = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "FASB", "CreateDate": "", "UpdateDate": "", "BreadCrumb": this.breadcrumbPath, "NavPath": this.pageNumsCountForHistory, "PageURL": this.router.url };
          this.historyHTTPCall(history);
        }
        else if (this.paraFound == false && this.destinationPara != "") {
          let history = { "Id": "-1", "UpdateUserId": "", "ApplicationSource": "FASB", "CreateDate": "", "UpdateDate": "", "BreadCrumb": this.breadcrumbPath, "NavPath": this.destinationPara, "PageURL": this.router.url };
          this.historyHTTPCall(history);
        }
      }
    }
  }

  historyHTTPCall(history) {
    this.httpCallService.addHistory(history).toPromise()
      .then(resp => console.log(resp))
      .catch(res => {
        console.log(res);
      });
  }

  outcome: boolean = false;
  paragraphTitleContent: any = [];
  getParagraphs(response) {
    //let paragraphContent = [];
    //this.paragraphTitleContent = [];
    this.paraFound = false;
    //if (this.userRole != "Basic" && (!this.title.includes("XBRL Elements"))) {
    //  for (let l = 0; l < response.paraGroups.length; l++) {
    //    paragraphContent = [];
    //    for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
    //      for (let i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
    //        let printTemp = false;
    //        if (this.addedparagraphList) {
    //          this.addedparagraphList.some(obj => obj.value === response.paraGroups[l].pgroups[k].paragraphNum[i]) ? printTemp = true : printTemp = false;
    //        }
    //        if (this.routerPart.length == 4) {
    //          if (this.routerPart[3] == (this.parameter[0] + "-" + this.parameter[1] + "-" + response.paraGroups[l].pgroups[k].paragraphNum[i])) { this.paraFound = true; }
    //        }
    //        if (i == 0) {
    //          let temp = {
    //            paragroup: response.paraGroups[l].pgroups[k].pgroupName,
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: printTemp,
    //            actionLabel: this.menuListItems
    //          }
    //          paragraphContent.push(temp);
    //        }
    //        else {
    //          let temp = {
    //            paragroup: "",
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: printTemp,
    //            actionLabel: this.menuListItems
    //          }
    //          paragraphContent.push(temp);
    //        }
    //      }
    //    }
    //    this.paragraphTitleContent.push({ title: response.paraGroups[l].title, paragraphContent: paragraphContent });
    //  }
    //  if (this.userRole != "Basic" && this.routerPart.length == 4 && this.normalUrl.split("/")[1] == this.routerPart[2]) {
    //    this.saveHistoryWithParagraph();
    //  }
    //  this.outcome = true;
    //  this.commonDataService.showLoader.next(false);
    //}
    //else if (this.title.includes("XBRL")) {
    //  this.outcome = true;
    //  this.commonDataService.showLoader.next(false);
    //}
    //else {
    //  for (let l = 0; l < response.paraGroups.length; l++) {
    //    paragraphContent = [];
    //    for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
    //      for (let i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
    //        if (i == 0) {
    //          let temp = {
    //            paragroup: response.paraGroups[l].pgroups[k].pgroupName,
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: false,
    //            actionLabel: []
    //          }
    //          paragraphContent.push(temp);
    //        }
    //        else {
    //          let temp = {
    //            paragroup: "",
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: false,
    //            actionLabel: []
    //          }
    //          paragraphContent.push(temp);
    //        }
    //      }
    //    }
    //    this.paragraphTitleContent.push({ title: response.paraGroups[l].title, paragraphContent: paragraphContent });
    //  }
    //  this.outcome = true;
    //  this.commonDataService.showLoader.next(false);
    //}
    this.outcome = true;
    this.commonDataService.showLoader.next(false);
    this.pageHeading = this.title.startsWith("S") ? this.title.substring(1) : this.title;
    this.browserTitle.setTitle(this.parameter[0] + "-" + this.parameter[1] + "-" + this.pageHeading);
    if (this.isRouteNav && this.router.url.slice(1).split("-").length > 3) {
      sessionStorage.setItem("paragraphNum", this.router.url.slice(1));
    }
    else if (localStorage.getItem('backButtonClicked') === 'false' || this.routerPart[3]?.startsWith("GUID")) {
      sessionStorage.setItem("paragraphNum", this.routerPart[3])
    }
  }
  outcomeSec: boolean = false;
  paragraphTitleContentSec: any = [];
  getParagraphsSec(response) {
    //let paragraphContentSec: any = [];
    //this.paragraphTitleContentSec = [];
    this.paraFound = false;
    //if (this.userRole != "Basic" && (!this.title.includes("XBRL Elements"))) {
    //  for (let l = 0; l < response.paraGroups.length; l++) {
    //    paragraphContentSec = [];
    //    for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
    //      for (let i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
    //        let printTemp: boolean = false;
    //        if (this.addedparagraphList) {
    //          this.addedparagraphList.some(obj => obj.value === response.paraGroups[l].pgroups[k].paragraphNum[i]) ? printTemp = true : printTemp = false;
    //        }
    //        if (this.routerPart.length == 4) {
    //          if (this.routerPart[3] == (this.parameter[0] + "-" + this.parameter[1] + "-" + response.paraGroups[l].pgroups[k].paragraphNum[i])) { this.paraFound = true; }
    //        }
    //        if (i == 0) {
    //          let temp = {
    //            paragroup: response.paraGroups[l].pgroups[k].pgroupName,
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: printTemp,
    //            actionLabel: this.menuListItems
    //          }
    //          paragraphContentSec.push(temp);
    //        }
    //        else {
    //          let temp = {
    //            paragroup: "",
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: printTemp,
    //            actionLabel: this.menuListItems
    //          }
    //          paragraphContentSec.push(temp);
    //        }
    //      }
    //    }
    //    this.paragraphTitleContentSec.push({ title: response.paraGroups[l].title, paragraphContent: paragraphContentSec });
    //  }
    //  if (this.userRole != "Basic" && this.routerPart.length == 4 && this.secUrl.split("/")[1] == this.routerPart[2]) {
    //    this.saveHistoryWithParagraph();
    //  }
    //  this.outcomeSec = true;
    //  this.commonDataService.showLoader.next(false);
    //}
    //else if (this.title.includes("XBRL")) {
    //  this.outcomeSec = true;
    //  this.commonDataService.showLoader.next(false);
    //}
    //else {
    //  for (let l = 0; l < response.paraGroups.length; l++) {
    //    let paragraphContentSec = [];
    //    for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
    //      for (let i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
    //        if (i == 0) {
    //          let temp = {
    //            paragroup: response.paraGroups[l].pgroups[k].pgroupName,
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: false,
    //            actionLabel: []
    //          }
    //          paragraphContentSec.push(temp);
    //        }
    //        else {
    //          let temp = {
    //            paragroup: "",
    //            id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //            paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //            paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //            paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //            paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //            paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //            paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //            paraContent: this.saitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //            PrintQueueAdded: false,
    //            actionLabel: []
    //          }
    //          paragraphContentSec.push(temp);
    //        }
    //      }
    //    }
    //    this.paragraphTitleContentSec.push({ title: response.paraGroups[l].title, paragraphContent: paragraphContentSec });
    //  }
    //  this.outcomeSec = true;
    //  this.commonDataService.showLoader.next(false);
    //}

    this.outcomeSec = true;
    this.commonDataService.showLoader.next(false);
    this.pageHeadingSec = this.title.startsWith("S") ? this.title : "S" + this.title;
    if (!this.hasActualContent) {
      this.browserTitle.setTitle(this.parameter[0] + "-" + this.parameter[1] + "-" + this.pageHeadingSec);
      if (this.isRouteNav && this.router.url.slice(1).split("-").length > 3) {
        sessionStorage.setItem("paragraphNum", this.router.url.slice(1));
      }
      else if (localStorage.getItem('backButtonClicked') === 'false' || this.routerPart[3]?.startsWith("GUID")) {
        sessionStorage.setItem("paragraphNum", this.routerPart[3])
      }
    }
  }

  pageHeadingSec: string = "";
  emailId: string = "";
  userRole: string = "";
  sessionCall: Subscription;
  getUserId() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.sessionCall = this.loginService.getSession().subscribe(data => {
        this.MapLoginData(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.MapLoginData(this.session.userInfo);
    }
  }

  crumbData;
  secUrlBreadcrumb;
  getBreadcrumb() {
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = leftNavigation.length - 1; i >= 0; i--) {
      this.crumbData = [];
      this.secUrlBreadcrumb = "";
      if (leftNavigation[i].itemData != null) {
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          if (leftNavigation[i].itemData[j].itemData != null) {
            for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
              if (leftNavigation[i].itemData[j].itemData[k].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemLink != "") {
                if (leftNavigation[i].itemData[j].itemData[k].itemLink == this.publicationId + "/" + this.pageId) {
                  this.crumbData.push(leftNavigation[i].item);
                  this.crumbData.push(leftNavigation[i].itemData[j].item);
                  this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                  if (leftNavigation[i].itemData[j].itemData[k].item.startsWith('S')) {
                    let normalMenus = leftNavigation[i].itemData[j].itemData[k].itemData.filter(x => x.item.split(" ")[0].trim() == leftNavigation[i].itemData[j].itemData[k].item.substring(1).split(" ")[0].trim());
                    if (normalMenus.length != 0) { this.secUrlBreadcrumb = normalMenus[0].itemLink; }
                  }
                  else {
                    let secMenus = leftNavigation[i].itemData[j].itemData[k].itemData.filter(x => x.item.split(" ")[0].trim() == "S" + leftNavigation[i].itemData[j].itemData[k].item.split(" ")[0].trim());
                    if (secMenus.length != 0) { this.secUrlBreadcrumb = secMenus[0].itemLink; }
                  }
                  return;
                }
              }
              else {
                if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                  for (let l = 0; l < leftNavigation[i].itemData[j].itemData[k].itemData.length; l++) {
                    if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != null && leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink != "") {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemLink == this.publicationId + "/" + this.pageId) {
                        this.crumbData.push(leftNavigation[i].item);
                        this.crumbData.push(leftNavigation[i].itemData[j].item);
                        this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                        this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                        if (leftNavigation[i].itemData[j].itemData[k].itemData[l].item.startsWith('S')) {
                          let normalMenus = leftNavigation[i].itemData[j].itemData[k].itemData.filter(x => x.item.split(" ")[0].trim() == leftNavigation[i].itemData[j].itemData[k].itemData[l].item.substring(1).split(" ")[0].trim());
                          if (normalMenus.length != 0) { this.secUrlBreadcrumb = normalMenus[0].itemLink; }
                        }
                        else {
                          let secMenus = leftNavigation[i].itemData[j].itemData[k].itemData.filter(x => x.item.split(" ")[0].trim() == "S" + leftNavigation[i].itemData[j].itemData[k].itemData[l].item.split(" ")[0].trim());
                          if (secMenus.length != 0) { this.secUrlBreadcrumb = secMenus[0].itemLink; }
                        }
                        return;
                      }
                    }
                    else {
                      if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                        for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                          if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].itemLink == this.publicationId + "/" + this.pageId) {
                            this.crumbData.push(leftNavigation[i].item);
                            this.crumbData.push(leftNavigation[i].itemData[j].item);
                            this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].item);
                            this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].item);
                            this.crumbData.push(leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item);

                            if (leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item.startsWith('S')) {
                              let normalMenus = leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.filter(x => x.item.split(" ")[0].trim() == leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item.split(" ")[0].substring(1).trim());
                              if (normalMenus.length != 0) { this.secUrlBreadcrumb = normalMenus[0].itemLink; }
                            }
                            else {
                              let secMenus = leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData.filter(x => x.item.split(" ")[0].trim() == "S" + leftNavigation[i].itemData[j].itemData[k].itemData[l].itemData[m].item.split(" ")[0].trim());
                              if (secMenus.length != 0) { this.secUrlBreadcrumb = secMenus[0].itemLink; }
                            }

                            return;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  pageNumsForCount: string = "";
  loggedInUserInfo;
  breadcrumbSession: Subscription;
  MapLoginData(loginData) {
    if (loginData != null) {
      this.loggedInUserInfo = loginData;
    }
    let leftNavigation = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    if (leftNavigation == undefined || leftNavigation == null) {
      this.breadcrumbSession = this.graphQLService.GetBreadcrumbSession(this.publicationId + "/" + this.pageId).subscribe(data => {
        this.crumbData = JSON.parse(JSON.stringify(data)).crumbData;
        this.matchParaNumbers(loginData);
      });
    }
    else {
      this.getBreadcrumb();
      this.matchParaNumbers(loginData);
    }
  }
  relatedProposedASUCall: Subscription;
  pageNumsCountForHistory: string = "";
  matchParaNumbers(loginData) {
    if (this.crumbData.length !== 0) {
      if (this.crumbData[0] != "Other Sources") {
        this.IsContentPage = true;
        this.pageNumsForCount = "";
        this.pageNumsCountForHistory = "";
        this.breadcrumbPath = this.crumbData[0] + "~";
        for (let i = 1; i < this.crumbData.length; i++) {
          if (i != this.crumbData.length - 1) {
            if (!this.crumbData[i].split(" ")[0].includes("X")) {
              this.pageNumsForCount += this.crumbData[i].split(" ")[0] + "-";
              this.pageNumsCountForHistory += this.crumbData[i].split(" ")[0] + "-";
              this.breadcrumbPath += this.crumbData[i] + "~";
            }
          }
          else {
            if (this.crumbData[i].split(" ")[0].startsWith('S')) {
              this.pageNumsForCount += this.crumbData[i].split(" ")[0].substring(1);
            } else { this.pageNumsForCount += this.crumbData[i].split(" ")[0]; }
            this.pageNumsCountForHistory += this.crumbData[i].split(" ")[0];
            this.breadcrumbPath += this.crumbData[i];
          }
        }
      }
      else { this.IsContentPage = false; this.browserTitle.setTitle(this.crumbData[1] + " - " + this.crumbData[2]); }
      this.parameter = this.pageNumsForCount.split("-");
      this.topic_subtopicNum = this.parameter[0] + "-" + this.parameter[1] + "-";


      this.commonDataService.navDataContentPage.next(this.crumbData);
      //this.breadcrumbPath = this.crumbData.join("~");
      this.commonDataService.breadcrumbPath.next(this.breadcrumbPath);
      this.commonDataService.emailId.next(this.loggedInUserInfo.user.email);
      this.emailId = this.loggedInUserInfo.user.email;
      this.userRole = this.loggedInUserInfo.user.roles;
      //this.getSecContent()
      if (this.IsContentPage) {
        this.getSecContent();
        if (!this.parameter[2].includes("75")) {
          this.relatedProposedASUCall = this.graphQLService.getRelatedpropsedASU(this.parameter[0], this.parameter[1], this.parameter[2]).subscribe(relatedASUs => { if (relatedASUs?.hits?.hitsList.length > 0) { this.showProposedASU = true; } else { this.showProposedASU = false; } })
        }
      }
      if (this.IsContentPage) {
        this.getActionMenuLabels();
      }
      if (!this.IsContentPage) {
        this.getOtherSourceContent(this.publicationId, this.pageId);
      }
    }
  }

  otherSourceTitle: string = "";
  otherSourceContent: any;
  pageDataCall: Subscription;
  getOtherSourceContent(publicationId: string, pageId: string) {
    let pageHeader = { "publicationId": publicationId, "pageId": pageId, "pageName": "", "pageNavPath": "", "PendingContentIntegrationData": [] };
    this.pageDataCall = this.graphQLService.getPageData(pageHeader).subscribe((result) => {
      this.otherSourceTitle = result.contentPageTitle;
      //this.TopicTitle = this.apiResponse.topicTitle;
      this.otherSourceContent = this.sanitizer.bypassSecurityTrustHtml(result.otherSourcePara);
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  backTo: string = "";
  elementName: string = "";
  reference: string = "";
  referenceOther: string = "";
  globalDataCall: Subscription;
  menuListItems: string[] = [];
  getActionMenuLabels() {
    this.globalDataCall = this.graphQLService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        let labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        if (this.userRole != "Basic") {
          this.menuListItems.push(labels.filter(x => x.key == "addBookmark_header").map(y => y.value)[0]);
          this.menuListItems.push(labels.filter(x => x.key == "addAnnotation_header").map(y => y.value)[0]);
        }
        this.menuListItems.push(labels.filter(x => x.key == "provideFeedback_header").map(y => y.value)[0]);
        this.menuListItems.push(labels.filter(x => x.key == "seeXBRLElements_Header").map(y => y.value)[0]);
        this.menuListItems.push(labels.filter(x => x.key == "print_addToQueue").map(y => y.value)[0]);
        this.backTo = labels.filter(x => x.key == "backTo_Label").map(y => y.value);
        this.elementName = labels.filter(x => x.key == "elementName_Label").map(y => y.value);
        this.reference = labels.filter(x => x.key == "referenceInThisSubtopic_Header").map(y => y.value);
        this.referenceOther = labels.filter(x => x.key == "referenceInOtherSubtopic_Header").map(y => y.value);
      }
    });
  }

  getPrintSession() {
    this.addedparagraphList = [];
    this.paragraphIdsList = [];
    this.printqueueAddedList = [];
    let printQueueData = JSON.parse(localStorage.getItem("SetPrintQueueSession"));
    if (printQueueData) {
      if (printQueueData != null && printQueueData.ParagraphIdsList != null) {
        this.addedparagraphList = printQueueData.ParagraphIdsList;
        this.paragraphIdsList = printQueueData.ParagraphIdsList;
        this.printqueueAddedList = printQueueData.printQueueAddedList;
      }
    }
  }

  OpenArchive() {
    this.commonDataService.archiveSecUrl.next(this.secUrl);
    this.commonDataService.archiveNormalUrl.next(this.normalUrl);
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("Archive");
  }
  OpenWhatLinksHere() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.whatLinksHereParams.next(this.pageNumsForCount);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("What Links Here");
    this.commonDataService.hasSecContent.next(this.hasSecContent);
    this.commonDataService.hasActualContent.next(this.hasActualContent);
    this.commonDataService.invokedFromTOC.next(false);
  }
  OpenPCS() {
    let pageUrl = this.publicationId + '/' + this.pageId;
    let PCS = { url: pageUrl };
    localStorage.setItem("PCSInput", JSON.stringify(PCS));
    this.router.navigateByUrl("/pendingcontentpageviewer");

  }

  backToWhatLinksHerePage() {
    this.router.navigateByUrl(this.whatLinksHereBackButtonUrl);
  }

  actualContent; ContentPath;
  hasActualContent: boolean = true;
  normalUrl: string = "";
  secUrl: string = "";
  normalPageName: string = "";
  getSecContent() {
    this.outcome = false;
    this.outcomeSec = false;
    if (localStorage.getItem("DefaultSecView") == "false") {
      this.ShowSecContent = false;
    }
    else {
      this.ShowSecContent = true;
    }
    if (this.crumbData[this.crumbData.length - 1].startsWith('S')) {
      localStorage.setItem("SecClicked", "SecContentStarted");
      if (this.secUrlBreadcrumb != "") {
        this.hasActualContent = true;
        this.ContentPath = this.secUrlBreadcrumb;
        this.pageName = "S" + this.ContentPath.split("/")[2];
        this.normalUrl = this.ContentPath.split("/")[0] + "/" + this.ContentPath.split("/")[1];
        this.normalPageName = this.crumbData[this.crumbData.length - 1].substring(1);
      }
      else {
        this.outcome = true;
        this.normalUrl = "";
        this.hasActualContent = false;
        this.normalPageName = this.crumbData[this.crumbData.length - 1].substring(1);
        this.title = this.crumbData[this.crumbData.length - 1].substring(1);
      }
      this.secUrl = this.publicationId + "/" + this.pageId;
    }
    else {
      this.hasActualContent = true;
      this.normalUrl = this.publicationId + "/" + this.pageId;
      this.secUrl = this.secUrlBreadcrumb;
      this.normalPageName = this.crumbData[this.crumbData.length - 1];
    }
    this.secContent = [];
    if (this.secUrl != "") {
      this.secContent = this.secUrlBreadcrumb;
      this.hasSecContent = true;
    }
    else {
      this.hasSecContent = false;
      this.secContent = "";
    }
    this.getPageContent()
    if (this.userRole != "Basic" && this.routerPart.length == 3) {
      this.saveHistory();
    }
  }

  OpenRelatedContent() {
    this.commonDataService.ASUParams.next(this.pageNumsForCount);
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.rightOverlayOption.next("Related praposed asus");

  }

  onRightClick(event) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (ahref.includes("-") && ahref.split("-").length >= 2) {
        let navPath = ahref.split("-");
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        if (ahref.toLowerCase().trim() == 'about the codification' && event?.currentTarget?.classList?.contains('generalNote')) {
          event.srcElement.setAttribute("href", "/" + 'about-us');

        }
        else {
          let otherSourceUrlParts = event.target.getAttribute('href').split("/");
          let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
          event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
        }
      }
    }
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
    for (let i = 8; i >= 0; i--) {
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }

  navPathTreeCall: Subscription;
  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        let url = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
        event.srcElement.setAttribute("href", "/" + url + "/" + ahref);
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }

  openLinkById(event) {
    this.openLink.linkClicked(event);
  }

  // Below method created for search highlighting of html string
  highlightSearchText(searchQuery: string, synonyms: string[], htmlText: any): string {
    //searchQuery = "";
    //synonyms = [];
    if (searchQuery == null || searchQuery == undefined || searchQuery == '')
      return htmlText;
    //searchQuery.indexOf("\"")
    if (searchQuery == undefined || searchQuery == null)
      return htmlText;
    let searchQ = [];
    if (searchQuery.indexOf("\"") == 0) {
      searchQ.push(searchQuery.substring(1, searchQuery.lastIndexOf("\"")));
      return this.highlightMatches(searchQ, htmlText);
    }
    else {
      searchQ = searchQuery?.split(" "); // if nultiple words available in search string
      if (synonyms != null && synonyms != undefined && synonyms.length >= 1) {
        searchQ = searchQ.concat(synonyms);
      }

      if (localStorage.getItem("hilightedElasticTerms") != null && localStorage.getItem("hilightedElasticTerms") != undefined && localStorage.getItem("hilightedElasticTerms").length > 0) {
        searchQ = searchQ.concat(localStorage.getItem("hilightedElasticTerms").split(","));
      }
      searchQ = [...new Set(searchQ)].sort(function (a, b) { return b.length - a.length });
    }


    for (let query of searchQ) {
      const searchRegex = new RegExp(`(${query.trim()})(?![^<]*>)`, "gi");  // Regular expression for replacing searched keyword without modifying links
      for (let i = 0; i < htmlText.length; i++) {
        if (htmlText[i]['paragraphContent'] != null && htmlText[i]['paragraphContent'] != undefined) {
          for (let j = 0; j < htmlText[i]['paragraphContent'].length; j++) {
            //let doc = parser.parseFromString(htmlText[i]['paragraphContent'][j]['paraContent'], 'text/html');
            htmlText[i]['paragraphContent'][j]['paraContent'] = htmlText[i]['paragraphContent'][j]['paraContent'].replace(searchRegex, '<span class="highlighted">$1</span>');
          }
        }
        if (htmlText[i]['contentPageBody'] != null && htmlText[i]['contentPageBody'] != undefined) {
          htmlText[i]['contentPageBody'] = htmlText[0]['contentPageBody'].replace(searchRegex, '<span class="highlighted">$1</span>');
        }
      }
    }
    return htmlText;
  }

  highlightMatches(terms: string[], htmlText: any): string {
    const regexString = terms.map(term => `(${term})`).join('|');
    const searchRegex = new RegExp(regexString, 'gi');
    for (let i = 0; i < htmlText.length; i++) {
      if (htmlText[i]['paragraphContent'] != null && htmlText[i]['paragraphContent'] != undefined) {
        for (let j = 0; j < htmlText[i]['paragraphContent'].length; j++) {
          //let doc = parser.parseFromString(htmlText[i]['paragraphContent'][j]['paraContent'], 'text/html');
          htmlText[i]['paragraphContent'][j]['paraContent'] = htmlText[i]['paragraphContent'][j]['paraContent'].replace(searchRegex, '<span class="highlighted">$1</span>');
        }
      }
      if (htmlText[i]['contentPageBody'] != null && htmlText[i]['contentPageBody'] != undefined) {
        htmlText[i]['contentPageBody'] = htmlText[0]['contentPageBody'].replace(searchRegex, '<span class="highlighted">$1</span>');
      }
    }

    return htmlText;
  }

}
